export enum MapsEnum {
  GEOFENCE_STANDARD_SIZE = 10000,
  GEOFENCE_SIZE = 100,
  GEOFENCE_MAX_SIZE = 100000,
  EARTH_RADIUS = 6251800,
  MIN_DISTANCE_OPTIMIZATOR = 200,
}
